import { useEffect } from "react"

interface CameraFlashProps {
  /** Fires after the flash has played, so the caller can advance the flow. */
  onComplete: () => void
  /** How long the white flash stays up, in ms. */
  durationMs?: number
}

/**
 * Full-screen white shutter flash. Covers the whole viewport above everything —
 * the camera preview, header and controls — for a brief moment to mask the
 * capture → result transition. Shared by the selfie and palm capture flows so the
 * flash looks and behaves the same everywhere.
 */
export function CameraFlash({ onComplete, durationMs = 400 }: CameraFlashProps) {
  useEffect(() => {
    const id = window.setTimeout(onComplete, durationMs)
    return () => window.clearTimeout(id)
  }, [onComplete, durationMs])

  return <div aria-hidden className="pointer-events-none fixed inset-0 z-[1001] bg-white" />
}
